import applyIoSanitaConfig from 'io-sanita-theme/config/ioSanitaConfig';

const applyConfig = (config) => {
  return applyIoSanitaConfig(config);
};

export default applyConfig;
